import { render, staticRenderFns } from "./ModalCancelSubscription.vue?vue&type=template&id=529c95c5&scoped=true"
import script from "./ModalCancelSubscription.vue?vue&type=script&lang=js"
export * from "./ModalCancelSubscription.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelSubscription.vue?vue&type=style&index=0&id=529c95c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c95c5",
  null
  
)

export default component.exports